// Moments in words, shared by the charts and their captions. Kept apart
// from the chart module so a caption can name a moment without pulling
// Chart.js into the eager bundle: a conversation may hold no chart at all.

/** A moment in a caption: date and time to the minute, in words. */
export function momentLabel(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** A moment on a narrow time axis: the day alone. */
export function shortDay(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
  });
}

/** A moment on a time axis: day and time, the year left to the caption. */
export function shortMoment(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
